export interface Article {
  id: string;
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categorySlug: string;
  publishedAt: string;
  readTime: string;
  imageSeq: string;
  tags: string[];
}

export interface Category {
  id: string;
  slug: string;
  name: string;
  description: string;
  icon: string;
  articleCount: number;
  imageSeq: string;
}

export const categories: Category[] = [
  {
    id: "cat-1",
    slug: "pingtai-daohang",
    name: "平台导航",
    description: "开云平台各入口地址汇总，确保您访问正确的官方渠道，避免进入仿冒网站。",
    icon: "ri-compass-3-line",
    articleCount: 8,
    imageSeq: "cat-nav-01",
  },
  {
    id: "cat-2",
    slug: "zhuce-denglu",
    name: "注册登录",
    description: "详细的开云平台注册与登录流程指引，帮助新用户快速完成账号创建与安全验证。",
    icon: "ri-user-add-line",
    articleCount: 6,
    imageSeq: "cat-reg-01",
  },
  {
    id: "cat-3",
    slug: "shiyong-zhinan",
    name: "使用指南",
    description: "涵盖开云平台各项功能的使用教程，从基础操作到高级技巧，助您高效使用平台服务。",
    icon: "ri-book-open-line",
    articleCount: 10,
    imageSeq: "cat-guide-01",
  },
  {
    id: "cat-4",
    slug: "changjian-wenti",
    name: "常见问题",
    description: "汇集用户在使用开云平台过程中最常见的问题与解决方案，快速排查疑难杂症。",
    icon: "ri-question-answer-line",
    articleCount: 12,
    imageSeq: "cat-faq-01",
  },
  {
    id: "cat-5",
    slug: "zuixin-dongtai",
    name: "最新动态",
    description: "开云平台最新公告、功能更新与行业资讯，及时掌握平台变化与发展方向。",
    icon: "ri-flashlight-line",
    articleCount: 5,
    imageSeq: "cat-news-01",
  },
  {
    id: "cat-6",
    slug: "anquan-fanghu",
    name: "安全防护",
    description: "账号安全设置、双重验证、防钓鱼指南等重要安全防护知识，保障您的账户安全。",
    icon: "ri-shield-check-line",
    articleCount: 7,
    imageSeq: "cat-sec-01",
  },
];

export const articles: Article[] = [
  {
    id: "art-1",
    slug: "kaiyun-guanfang-rukou-zhengque-dizhi",
    title: "开云平台官方入口正确地址汇总（2026最新版）",
    excerpt: "本文整理了开云平台所有官方认证的访问入口地址，帮助您辨别真伪，避免误入仿冒网站造成损失。",
    content: `<p>随着开云平台的不断发展，网络上出现了大量仿冒网站，给用户的账号安全和资金安全带来了严重威胁。本文汇总了所有经官方认证的访问入口，帮助您安全、快速地找到正确的开云平台地址。</p>
<h2>一、官方主域名入口</h2>
<p>开云平台目前使用的主要官方域名包括以下几个，所有域名均已通过安全认证：</p>
<ul>
<li><strong>主域名：</strong>kaiyun.com（推荐首选访问）</li>
<li><strong>备用域名：</strong>kaiyun.cn</li>
<li><strong>国际域名：</strong>kaiyun-global.com</li>
</ul>
<h2>二、如何辨别真伪网站</h2>
<p>访问开云平台时，请注意以下几点辨别真伪：</p>
<ol>
<li>检查网址是否为上述官方域名，注意拼写是否完全一致</li>
<li>确认页面带有SSL安全证书（地址栏显示锁形图标）</li>
<li>官方页面不会要求您提供支付密码以外的敏感信息</li>
<li>如有疑问，可通过本站提供的导航链接进行访问验证</li>
</ol>
<h2>三、移动端访问建议</h2>
<p>建议通过官方APP或官方微信公众号访问，避免通过不明来源的链接或二维码进入平台。</p>
<h2>四、常见仿冒手段警示</h2>
<p>近期发现的仿冒手段包括：域名拼写相似（如kalyun、kaiyun-vip等）、冒充客服索要验证码、发送伪造的中奖通知等。请广大用户提高警惕。</p>`,
    category: "平台导航",
    categorySlug: "pingtai-daohang",
    publishedAt: "2026-07-15",
    readTime: "5分钟",
    imageSeq: "art-nav-01",
    tags: ["官方入口", "网址导航", "安全访问"],
  },
  {
    id: "art-2",
    slug: "xinyonghu-zhuce-xiangxi-jiaocheng",
    title: "新用户注册开云账号详细图文教程",
    excerpt: "一步步教您完成开云平台账号注册，包括手机验证、实名认证等完整流程，新手也能轻松上手。",
    content: `<p>注册开云平台账号是使用平台服务的第一步，本教程将手把手带您完成整个注册流程，确保您能顺利创建账号并开始使用。</p>
<h2>一、注册前的准备工作</h2>
<p>在开始注册之前，请确保您已准备以下材料：</p>
<ul>
<li>本人实名认证的手机号码</li>
<li>有效的身份证件（身份证或护照）</li>
<li>一个可用的电子邮箱地址</li>
</ul>
<h2>二、注册步骤详解</h2>
<h3>步骤1：进入注册页面</h3>
<p>通过本站提供的官方导航入口进入开云平台首页，点击右上角的「注册」按钮进入注册页面。</p>
<h3>步骤2：填写基本信息</h3>
<p>输入您的手机号码，点击「获取验证码」，将收到的短信验证码填入对应位置。设置登录密码，建议使用字母+数字+特殊字符的组合以提高安全性。</p>
<h3>步骤3：完成实名认证</h3>
<p>根据页面提示上传身份证正反面照片，系统将自动进行信息核验。通常情况下认证审核在1-2个工作日内完成。</p>
<h3>步骤4：设置安全信息</h3>
<p>建议设置密保问题和答案，绑定备用邮箱，开启登录保护功能，全方位保障账号安全。</p>
<h2>三、注册常见问题</h2>
<p>如遇到验证码收不到的情况，请检查手机信号是否正常、是否被拦截软件屏蔽。如问题持续，建议联系平台客服寻求帮助。</p>`,
    category: "注册登录",
    categorySlug: "zhuce-denglu",
    publishedAt: "2026-07-10",
    readTime: "8分钟",
    imageSeq: "art-reg-01",
    tags: ["注册教程", "账号创建", "新手入门"],
  },
  {
    id: "art-3",
    slug: "kaiyun-pingtai-mianfei-zhuce",
    title: "开云平台免费注册流程与注意事项",
    excerpt: "了解开云平台的免费注册政策、账户类型区别以及注册过程中的重要注意事项。",
    content: `<p>开云平台为广大用户提供免费注册服务，本文将详细介绍免费注册的完整流程及相关注意事项。</p>
<h2>一、免费注册政策说明</h2>
<p>开云平台基础账号注册完全免费，用户注册后即可使用平台的基础功能服务。部分高级功能可能需要完成额外的资质审核，但不会收取注册费用。如果遇到要求支付注册费的情况，请立即停止操作，这极有可能是仿冒网站。</p>
<h2>二、账户类型介绍</h2>
<p>开云平台目前提供以下几种账户类型：</p>
<ul>
<li><strong>基础账户：</strong>完成手机验证即可开通，满足大部分用户的日常使用需求</li>
<li><strong>高级账户：</strong>完成实名认证后升级，享有更多功能权限</li>
<li><strong>企业账户：</strong>需提交企业资质材料，适用于商业用户</li>
</ul>
<h2>三、注册注意事项</h2>
<ol>
<li>请务必使用本人真实信息注册，否则可能影响后续的实名认证和账户使用</li>
<li>注册手机号将作为重要的安全验证方式，请确保该号码长期有效</li>
<li>密码设置后请妥善保管，切勿告知他人</li>
<li>建议注册后立即开启双重验证功能</li>
</ol>`,
    category: "注册登录",
    categorySlug: "zhuce-denglu",
    publishedAt: "2026-07-05",
    readTime: "6分钟",
    imageSeq: "art-reg-02",
    tags: ["免费注册", "账户类型", "注意事项"],
  },
  {
    id: "art-4",
    slug: "kaiyun-pingtai-jichu-caozuo-jiaocheng",
    title: "开云平台基础操作完整教程",
    excerpt: "从界面介绍到核心功能使用，全面讲解开云平台的基础操作，帮助新用户快速熟悉平台。",
    content: `<p>初次使用开云平台时，了解基本操作可以帮助您更快地上手。本文将系统性地介绍平台的基础功能和操作方式。</p>
<h2>一、平台主界面介绍</h2>
<p>登录后您将看到平台主界面，主要包含以下几个区域：</p>
<ul>
<li><strong>顶部导航栏：</strong>包含功能菜单、消息通知和个人中心入口</li>
<li><strong>功能面板：</strong>展示常用功能的快捷入口</li>
<li><strong>内容区域：</strong>显示主要内容，根据所选功能动态变化</li>
<li><strong>侧边栏：</strong>提供辅助功能和快捷操作</li>
</ul>
<h2>二、核心功能操作指南</h2>
<h3>个人信息管理</h3>
<p>点击右上角头像进入个人中心，可查看和编辑个人资料、修改密码、管理安全设置等。</p>
<h3>通知消息查看</h3>
<p>顶部导航栏的消息图标会显示未读通知数量，点击可查看系统消息、活动通知等重要信息。</p>
<h3>搜索功能</h3>
<p>使用顶部的搜索框可以快速查找平台内的功能和内容，支持关键词模糊匹配。</p>
<h2>三、高级技巧</h2>
<p>熟练使用快捷键可以大幅提升操作效率。建议在个人设置中自定义常用的快捷操作。</p>`,
    category: "使用指南",
    categorySlug: "shiyong-zhinan",
    publishedAt: "2026-06-28",
    readTime: "10分钟",
    imageSeq: "art-guide-01",
    tags: ["操作教程", "基础功能", "新手指南"],
  },
  {
    id: "art-5",
    slug: "zhanghu-anquan-shezhigonglue",
    title: "账户安全设置全方位攻略",
    excerpt: "详细讲解如何为您的开云账户设置多重安全保护，包括密码管理、双重验证和异常登录提醒。",
    content: `<p>账户安全是使用开云平台的重中之重。本文汇总了所有可用的安全设置选项，帮助您构建全方位的账户防护体系。</p>
<h2>一、密码安全最佳实践</h2>
<p>设置一个强密码是保护账户的第一道防线：</p>
<ul>
<li>密码长度至少12位</li>
<li>包含大写字母、小写字母、数字和特殊字符</li>
<li>避免使用生日、手机号等容易被猜测的信息</li>
<li>定期更换密码，建议每3个月更换一次</li>
<li>不同平台使用不同的密码</li>
</ul>
<h2>二、双重验证设置</h2>
<p>开启双重验证后，即使密码泄露，攻击者也无法登录您的账户。开云平台支持以下验证方式：</p>
<ol>
<li>短信验证码验证</li>
<li>谷歌身份验证器（推荐）</li>
<li>邮箱验证码验证</li>
</ol>
<h2>三、异常登录提醒</h2>
<p>建议开启异地登录提醒和设备管理功能，当账户在新设备或新地点登录时，系统会立即发送通知。</p>
<h2>四、防钓鱼指南</h2>
<p>警惕冒充官方的钓鱼邮件和短信，官方不会通过任何方式索要您的密码或验证码。</p>`,
    category: "安全防护",
    categorySlug: "anquan-fanghu",
    publishedAt: "2026-06-20",
    readTime: "7分钟",
    imageSeq: "art-sec-01",
    tags: ["账户安全", "双重验证", "防钓鱼"],
  },
  {
    id: "art-6",
    slug: "kaiyun-zhanghao-zhaohui-mima-liucheng",
    title: "开云账号忘记密码？完整找回流程详解",
    excerpt: "忘记密码不用慌，本文详细介绍通过手机、邮箱等多种方式找回开云平台账号密码的完整流程。",
    content: `<p>忘记密码是很多用户都会遇到的问题。开云平台提供了多种安全便捷的密码找回方式，本文将逐一介绍。</p>
<h2>一、通过绑定手机号找回</h2>
<p>这是最常用的找回方式，步骤如下：</p>
<ol>
<li>在登录页面点击「忘记密码」</li>
<li>选择「通过手机号找回」</li>
<li>输入绑定的手机号码</li>
<li>接收并输入短信验证码</li>
<li>设置新密码</li>
</ol>
<h2>二、通过绑定邮箱找回</h2>
<p>如果您绑定了邮箱，也可以通过邮箱接收重置链接来设置新密码。请检查邮件的垃圾箱，以防重置邮件被误判为垃圾邮件。</p>
<h2>三、通过客服协助找回</h2>
<p>如果以上方式均无法使用，可以联系开云平台客服，提供相关身份验证信息后申请人工协助找回。</p>
<h2>四、密码找回注意事项</h2>
<ul>
<li>重置密码后，所有已登录设备会被强制下线</li>
<li>新密码不能与最近3次使用过的密码相同</li>
<li>建议密码重置后检查账户最近的操作记录</li>
</ul>`,
    category: "常见问题",
    categorySlug: "changjian-wenti",
    publishedAt: "2026-06-15",
    readTime: "5分钟",
    imageSeq: "art-faq-01",
    tags: ["密码找回", "账号恢复", "常见问题"],
  },
  {
    id: "art-7",
    slug: "kaiyun-pingtai-2026nian-gongneng-gengxin",
    title: "开云平台2026年第三季度功能更新公告",
    excerpt: "了解开云平台最新上线的功能改进与优化，包括界面升级、安全增强及新增的便捷工具。",
    content: `<p>开云平台于2026年第三季度进行了多项功能更新与优化，致力于为用户提供更优质的服务体验。以下是本次更新的详细内容。</p>
<h2>一、界面视觉升级</h2>
<p>平台整体UI进行了全面优化，采用更简洁现代的设计风格，提升视觉舒适度和操作效率。主要改进包括：</p>
<ul>
<li>优化了导航菜单结构，功能入口更加清晰</li>
<li>改进了移动端适配，手机访问体验更流畅</li>
<li>新增了深色模式，减少夜间使用的视觉疲劳</li>
</ul>
<h2>二、安全功能增强</h2>
<p>持续加强平台安全防护能力：</p>
<ul>
<li>新增人脸识别登录功能</li>
<li>升级了风险控制系统，异常行为检测更精准</li>
<li>增加了设备指纹识别技术</li>
</ul>
<h2>三、新增便捷工具</h2>
<p>根据用户反馈新增了多项实用工具，提升日常使用效率。</p>
<h2>四、性能优化</h2>
<p>页面加载速度平均提升了35%，降低了服务器响应延迟，为用户带来更丝滑的操作体验。</p>`,
    category: "最新动态",
    categorySlug: "zuixin-dongtai",
    publishedAt: "2026-08-01",
    readTime: "4分钟",
    imageSeq: "art-news-01",
    tags: ["功能更新", "平台公告", "2026"],
  },
  {
    id: "art-8",
    slug: "fang-diaoyu-wangzhan-shibie-jiqiao",
    title: "如何识别仿冒钓鱼网站？实用技巧分享",
    excerpt: "学会识别仿冒网站的特征，掌握安全上网的基本技能，保护您的账户信息和资金安全不受侵害。",
    content: `<p>随着网络钓鱼技术的不断升级，仿冒网站越来越难以辨别。本文整理了识别钓鱼网站的实用技巧，帮助您远离网络诈骗。</p>
<h2>一、检查网站域名</h2>
<p>仿冒网站往往会使用与官方域名极为相似的地址：</p>
<ul>
<li>注意字母替换：如 kaiyun 被改为 kalyun、kaiiyun 等</li>
<li>注意多余字符：如 kaiyun-vip、kaiyun-2026 等并非官方域名</li>
<li>查看域名后缀是否正确</li>
</ul>
<h2>二、查看安全证书</h2>
<p>点击浏览器地址栏的锁形图标，查看网站的SSL证书信息。正规网站的证书信息完整且与网站主体一致。</p>
<h2>三、注意页面细节</h2>
<p>仿冒网站通常存在以下问题：</p>
<ul>
<li>页面排版粗糙，存在错别字或语法错误</li>
<li>图片模糊或与官方风格不一致</li>
<li>功能不完整，部分链接无法点击</li>
</ul>
<h2>四、安全上网建议</h2>
<p>建议将官方网址添加到浏览器收藏夹，通过收藏夹访问而非搜索引擎点击广告链接。</p>`,
    category: "安全防护",
    categorySlug: "anquan-fanghu",
    publishedAt: "2026-06-10",
    readTime: "6分钟",
    imageSeq: "art-sec-02",
    tags: ["钓鱼网站", "安全技巧", "仿冒识别"],
  },
  {
    id: "art-9",
    slug: "kaiyun-shouji-app-xiazai-anjiao",
    title: "开云手机APP下载安装指南",
    excerpt: "详细介绍开云平台官方手机APP的下载渠道、安装步骤以及首次使用的配置建议。",
    content: `<p>使用开云官方手机APP可以获得更便捷的移动端体验。本文将指导您完成APP的下载、安装和初始设置。</p>
<h2>一、官方下载渠道</h2>
<p>请务必通过以下官方渠道下载APP：</p>
<ul>
<li><strong>官方网站：</strong>访问开云官网，在首页找到APP下载入口</li>
<li><strong>官方应用商店：</strong>在苹果App Store或华为、小米等官方应用商店搜索下载</li>
<li><strong>官方微信公众号：</strong>关注公众号后在菜单中找到下载链接</li>
</ul>
<h2>二、安装步骤</h2>
<h3>安卓用户</h3>
<p>下载APK安装包后，如系统提示"未知来源"安装，请前往设置中允许本次安装。安装完成后建议删除安装包释放存储空间。</p>
<h3>iOS用户</h3>
<p>通过App Store直接下载安装即可，系统会自动完成安装流程。</p>
<h2>三、首次使用配置</h2>
<p>安装完成后，建议进行以下设置：开启指纹/面部识别登录、设置支付密码、开启消息推送通知。</p>`,
    category: "使用指南",
    categorySlug: "shiyong-zhinan",
    publishedAt: "2026-05-25",
    readTime: "5分钟",
    imageSeq: "art-guide-02",
    tags: ["APP下载", "移动端", "安装教程"],
  },
  {
    id: "art-10",
    slug: "kaiyun-kehu-zixun-lianxi-fangshi",
    title: "开云平台客户咨询与联系客服方式汇总",
    excerpt: "汇总开云平台所有官方客服渠道，包括在线客服、电话热线、邮件支持和社交媒体联系方式。",
    content: `<p>当您在使用开云平台过程中遇到问题时，可以通过以下官方渠道获取帮助和支持。</p>
<h2>一、在线客服</h2>
<p>登录开云平台后，点击右下角的在线客服图标，即可与客服人员实时沟通。在线客服服务时间为每日8:00-24:00。</p>
<h2>二、电话客服</h2>
<p>您也可以拨打官方客服热线获取人工服务。请注意，官方客服不会主动索要您的密码或验证码。</p>
<h2>三、邮件支持</h2>
<p>对于非紧急问题，可以通过官方客服邮箱提交工单，通常会在24小时内得到回复。</p>
<h2>四、社交媒体</h2>
<p>关注开云平台官方微博和微信公众号，获取最新公告和活动信息。</p>
<h2>五、常见自助服务</h2>
<p>大部分常见问题可以在平台的「帮助中心」找到答案，建议先查阅常见问题，可能会更快获得解决方案。</p>`,
    category: "常见问题",
    categorySlug: "changjian-wenti",
    publishedAt: "2026-05-18",
    readTime: "4分钟",
    imageSeq: "art-faq-02",
    tags: ["客服联系", "帮助支持", "联系方式"],
  },
];

export const faqs = [
  {
    id: "faq-1",
    question: "kaiyun.con 是什么网站？",
    answer: "kaiyun.con 是开云平台的第三方导航入口网站，为用户提供开云平台的官方地址导航、注册登录指引、使用教程以及常见问题解答等服务。本站旨在帮助用户快速定位并安全访问开云平台，节省查找时间。请注意，本站为导航信息聚合平台，非开云官方网站。",
  },
  {
    id: "faq-2",
    question: "如何通过 kaiyun.con 访问开云平台？",
    answer: "您可以通过本站首页提供的导航链接直接访问开云平台官方入口。所有导航链接均经过人工审核验证，确保指向正确的官方地址。建议将本站加入浏览器收藏夹，以便随时快速访问。",
  },
  {
    id: "faq-3",
    question: "开云平台注册需要收费吗？",
    answer: "开云平台基础账号注册完全免费。如果遇到任何要求支付注册费用的网站，请立即停止操作，这极有可能是仿冒网站。请通过本站提供的官方入口进行注册。",
  },
  {
    id: "faq-4",
    question: "忘记密码怎么办？",
    answer: "您可以通过绑定的手机号或邮箱找回密码。在登录页面点击「忘记密码」，按照提示操作即可。如果绑定的手机号已停用，请联系开云官方客服寻求人工协助。详细的找回流程请查看本站的「开云账号忘记密码？完整找回流程详解」文章。",
  },
  {
    id: "faq-5",
    question: "如何辨别开云平台的仿冒网站？",
    answer: "辨别仿冒网站主要注意以下几点：1）核对域名是否完全正确，注意相似字母的替换；2）检查页面是否有SSL安全证书（地址栏锁形图标）；3）官方网站不会索要支付密码；4）页面排版是否专业，有无错别字。本站的「安全防护」分类有更详细的辨别技巧介绍。",
  },
  {
    id: "faq-6",
    question: "kaiyun.con 和开云官方网站是什么关系？",
    answer: "kaiyun.con 是独立的第三方导航信息聚合平台，与开云官方不存在隶属关系。本站旨在为用户提供便利的导航服务和信息整理，所有关于开云平台的信息均来自公开渠道。如需使用开云平台服务，请通过本站提供的链接访问官方网站。",
  },
  {
    id: "faq-7",
    question: "如何在手机上使用开云平台？",
    answer: "您可以通过以下方式在手机上使用开云平台：1）下载官方APP（请通过本站导航入口访问官网下载）；2）使用手机浏览器访问官方移动版网站；3）关注官方微信公众号获取服务。详细安装指引请查看「开云手机APP下载安装指南」文章。",
  },
  {
    id: "faq-8",
    question: "本站提供的信息是否及时更新？",
    answer: "本站团队定期审核并更新所有导航信息和文章内容，确保信息的准确性和时效性。如发现任何信息过时或有误，欢迎通过关于我们页面的联系方式反馈给我们，我们将及时修正。",
  },
];